import { render, staticRenderFns } from "./OtherNews.vue?vue&type=template&id=7f5537d0&scoped=true&"
import script from "./OtherNews.vue?vue&type=script&lang=js&"
export * from "./OtherNews.vue?vue&type=script&lang=js&"
import style0 from "./OtherNews.vue?vue&type=style&index=0&id=7f5537d0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f5537d0",
  null
  
)

export default component.exports